// ════════════════════════════════════════════════════════════════
// 📜 B213 (AI_99) — diff de campos para a trilha de auditoria
// ════════════════════════════════════════════════════════════════
// Lógica PURA (sem firebase) para ser testável em jest sem mocks.
// A escrita no banco vive em trilhaAuditoria.ts.
//
// Lição do B110 (achado de Leonardo, AI_98): comparar VALORES, não
// chaves — as telas de edição mandam o objeto inteiro de volta e um
// diff por chave registraria todos os campos em toda edição.

// Metadados de escrita do app que nunca contam como "campo alterado".
export const CAMPOS_META_TRILHA = new Set([
  "id",
  "editadoPor",
  "editadoPorNome",
  "dataEdicao",
  "atualizadoEm",
  "criadoEm",
  "registradoPor",
  "registradoPorNome",
  "uploadPor",
  "uploadPorNome",
  "criadoPor",
  "criadoPorNome",
]);

// Remove `undefined` recursivamente (Firestore não aceita; e
// `{a: undefined}` deve ser igual a `{}` na comparação).
function limparUndefined(obj: any): any {
  if (obj === null || obj === undefined) return null;
  if (typeof obj !== "object") return obj;
  if (Array.isArray(obj)) return obj.map(limparUndefined);
  const resultado: any = {};
  Object.keys(obj).forEach((k) => {
    if (obj[k] !== undefined) resultado[k] = limparUndefined(obj[k]);
  });
  return resultado;
}

function serializar(v: any): string {
  return JSON.stringify(limparUndefined(v ?? null));
}

/**
 * Lista os campos cujo VALOR realmente mudou entre o doc atual e os
 * dados enviados pela tela de edição. Ignora metadados de escrita.
 */
export function calcularCamposAlterados(
  dadosNovos: Record<string, any>,
  docAtual: Record<string, any> | null | undefined,
  camposIgnorados: Set<string> = CAMPOS_META_TRILHA
): string[] {
  const atual = docAtual || {};
  return Object.keys(dadosNovos).filter(
    (k) =>
      !camposIgnorados.has(k) &&
      serializar(dadosNovos[k]) !== serializar(atual[k])
  );
}
